var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content open-view" }, [
    _c(
      "div",
      { staticClass: "details-view", staticStyle: { overflow: "auto" } },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.onlyView,
                expression: "!onlyView"
              }
            ],
            staticStyle: { "margin-top": "5px" }
          },
          [
            _c(
              "el-button",
              { attrs: { no: "Back" }, on: { click: _vm.back } },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Back")))]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "permission",
                    rawName: "v-permission",
                    value: ["button_OpenPrice_edit"],
                    expression: "['button_OpenPrice_edit']"
                  }
                ],
                attrs: {
                  disabled: _vm.isEditDisable,
                  type: "success",
                  no: "Edit"
                },
                on: { click: _vm.toEdit }
              },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "permission",
                    rawName: "v-permission",
                    value: ["button_OpenPrice_edit"],
                    expression: "['button_OpenPrice_edit']"
                  }
                ],
                attrs: { type: "primary", no: "add" },
                on: { click: _vm.toAdd }
              },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "permission",
                    rawName: "v-permission",
                    value: ["button_OpenPrice_edit"],
                    expression: "['button_OpenPrice_edit']"
                  }
                ],
                attrs: { type: "primary", disabled: !_vm.form, no: "copy" },
                on: {
                  click: function($event) {
                    return _vm.toCopy()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Copy")))]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "permission",
                    rawName: "v-permission",
                    value: ["button_OpenPrice_rpaControl"],
                    expression: "['button_OpenPrice_rpaControl']"
                  }
                ],
                attrs: {
                  type: "primary",
                  disabled:
                    !_vm.isRpaEnabled ||
                    !_vm.form ||
                    _vm.notRpaStart ||
                    _vm.isCompleted,
                  no: "start"
                },
                on: {
                  click: function($event) {
                    return _vm.toStartRPA()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_StartRPA")))]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "permission",
                    rawName: "v-permission",
                    value: ["button_OpenPrice_rpaControl"],
                    expression: "['button_OpenPrice_rpaControl']"
                  }
                ],
                attrs: {
                  type: "danger",
                  disabled:
                    !_vm.isRpaEnabled ||
                    !_vm.form ||
                    !_vm.notRpaStart ||
                    _vm.isCompleted,
                  no: "suspend"
                },
                on: {
                  click: function($event) {
                    return _vm.toSuspendRPA()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SuspendRPA")))]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "permission",
                    rawName: "v-permission",
                    value: ["button_OpenPrice_importFinalResult"],
                    expression: "['button_OpenPrice_importFinalResult']"
                  }
                ],
                attrs: {
                  type: "primary",
                  disabled: !_vm.form,
                  no: "importFinalResult"
                },
                on: {
                  click: function($event) {
                    return _vm.toImportFinalResult()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ImportFinalResult")))]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "permission",
                    rawName: "v-permission",
                    value: ["button_OpenPrice_edit"],
                    expression: "['button_OpenPrice_edit']"
                  }
                ],
                attrs: {
                  type: "primary",
                  disabled: !_vm.form || _vm.isCompleted,
                  no: "manuallyExportFile"
                },
                on: { click: _vm.toExportFile }
              },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ManuallyExportFile")))]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "permission",
                    rawName: "v-permission",
                    value: ["button_OpenPrice_delete"],
                    expression: "['button_OpenPrice_delete']"
                  }
                ],
                attrs: {
                  type: "danger",
                  disabled: _vm.isDeleteDisable,
                  no: "delete"
                },
                on: {
                  click: function($event) {
                    return _vm.toDelete()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
            )
          ],
          1
        ),
        _c("div", { staticClass: "main-content" }, [
          _c(
            "div",
            {
              staticClass: "section",
              staticStyle: { "margin-top": "5px", width: "100%" }
            },
            [
              _c("div", [
                _c("span", { staticClass: "title" }, [
                  _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_FilingBatchInfo")))
                ]),
                _c(
                  "span",
                  {
                    staticStyle: { "margin-left": "50px", "font-size": "15px" }
                  },
                  [_vm._v(_vm._s(_vm.filingStateLabel))]
                )
              ]),
              _c(
                "el-form",
                {
                  attrs: {
                    inline: true,
                    "label-width": "80px",
                    "label-position": "right"
                  }
                },
                [
                  _c(
                    "el-row",
                    { attrs: { type: "flex" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.onlyView ? 5 : 4 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_FilingBatchNo")
                              }
                            },
                            [
                              _c("el-input", {
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.form.filingBatchNo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "filingBatchNo", $$v)
                                  },
                                  expression: "form.filingBatchNo"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.onlyView ? 5 : 4 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_FilingDate")
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: true,
                                  no: "customsDate",
                                  type: "date",
                                  "value-format": "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.form.filingDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "filingDate", $$v)
                                  },
                                  expression: "form.filingDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.onlyView ? 5 : 4 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("CargoMsg.Cargo_EffectiveDate")
                              }
                            },
                            [
                              _c("el-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  disabled: true,
                                  no: "customsDate",
                                  type: "date",
                                  "value-format": "yyyy-MM-dd"
                                },
                                model: {
                                  value: _vm.form.effectiveDate,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "effectiveDate", $$v)
                                  },
                                  expression: "form.effectiveDate"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 6 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: _vm.$t("CargoMsg.Cargo_Remarks") }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "200px" },
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.form.filingRemark,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "filingRemark", $$v)
                                  },
                                  expression: "form.filingRemark"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("el-col", { attrs: { span: _vm.onlyView ? 3 : 6 } })
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    { attrs: { type: "flex" } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: _vm.onlyView ? 6 : 5 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                "label-width": "80px",
                                label: _vm.$t("CargoMsg.Cargo_DeclareFile")
                              }
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "margin-top": "0px",
                                    "margin-bottom": "0px"
                                  }
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticStyle: { color: "blue" },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleExport(
                                            _vm.form.uploadFileId
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.form.uploadFileName))]
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.onlyView ? 8 : 7 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                "label-width": "100px",
                                label: _vm.$t("CargoMsg.Cargo_ImportFinalFile")
                              }
                            },
                            [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "margin-top": "0px",
                                    "margin-bottom": "0px"
                                  }
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticStyle: { color: "blue" },
                                      on: {
                                        click: function($event) {
                                          return _vm.handleExport(
                                            _vm.form.importResultFileId
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.form.importResultFileName)
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.onlyView ? 6 : 5 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                "label-width": "180px",
                                label: _vm.$t(
                                  "CargoMsg.Cargo_FiletotalRecordPass"
                                )
                              }
                            },
                            [
                              _c("el-input", {
                                staticStyle: { width: "140px" },
                                attrs: { disabled: true },
                                model: {
                                  value: _vm.form.filetotalRecordPass,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "filetotalRecordPass",
                                      $$v
                                    )
                                  },
                                  expression: "form.filetotalRecordPass"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: _vm.onlyView ? 4 : 7 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { "label-width": "0px" } },
                            [
                              _c(
                                "p",
                                {
                                  staticStyle: {
                                    "margin-top": "0px",
                                    "margin-bottom": "0px",
                                    "font-size": "14px",
                                    color: "red"
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_DeclareFinalLabel",
                                        [_vm.form.declareFinal]
                                      )
                                    )
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "tabs-container" },
            [
              _c(
                "el-tabs",
                {
                  staticStyle: { width: "100%" },
                  attrs: { lazy: true, type: "card" },
                  model: {
                    value: _vm.activeTabName,
                    callback: function($$v) {
                      _vm.activeTabName = $$v
                    },
                    expression: "activeTabName"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_FinalPriceInfo"),
                        name: "finalPrice"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "grid-wrapper",
                          staticStyle: { "padding-top": "5px", height: "100%" }
                        },
                        [
                          _c("cargo-ag-grid", {
                            ref: "tabFinalPrice",
                            attrs: {
                              "grid-options": _vm.tabFinalPrice.gridOptions,
                              "column-defs": _vm.tabFinalPrice.columnDefs,
                              "row-data": _vm.tabFinalPrice.rowData,
                              "show-side-bar": false,
                              "auto-fit-content": false
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_OpenPriceInfo"),
                        name: "openPrice"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "grid-wrapper",
                          staticStyle: { "padding-top": "5px", height: "100%" }
                        },
                        [
                          _c("cargo-ag-grid", {
                            ref: "tabOpenPrice",
                            attrs: {
                              "grid-options": _vm.tabOpenPrice.gridOptions,
                              "column-defs": _vm.dynamicColumnDefs,
                              "grid-params": _vm.tabOpenPrice.gridParams,
                              "row-data": _vm.tabOpenPrice.rowData,
                              "show-side-bar": false,
                              "auto-fit-content": false
                            },
                            on: {
                              "update:gridParams": function($event) {
                                return _vm.$set(
                                  _vm.tabOpenPrice,
                                  "gridParams",
                                  $event
                                )
                              },
                              "update:grid-params": function($event) {
                                return _vm.$set(
                                  _vm.tabOpenPrice,
                                  "gridParams",
                                  $event
                                )
                              }
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_Log"),
                        name: "opLog"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "grid-wrapper",
                          staticStyle: { "padding-top": "5px", height: "100%" }
                        },
                        [
                          _c("cargo-ag-grid", {
                            ref: "tabOpLog",
                            attrs: {
                              "grid-options": _vm.tabOpLog.gridOptions,
                              "column-defs": _vm.tabOpLog.columnDefs,
                              "row-data": _vm.tabOpLog.rowData,
                              "show-side-bar": false,
                              "auto-fit-content": false
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }